define('router',[
    // Libs
    'underscore', 'backbone', 'utils',
    // src
    'src/plugins/backbone.subrouter',
    // Controller
    'controllers/authentication',
    'controllers/supervisor',
    'controllers/member',
    'controllers/payment',
    'controllers/zoom',
], function (
    _, Backbone, U,
    // src
    SubRouter,
    // controller
    AuthenticationCtrl,
    SupervisorCtrl,
    MemberCtrl,
    PaymentCtrl,
    ZoomCtrl
) {

    var AppRouter = SubRouter.extend({
        routes: {
            '*actions': 'index'
        },
        subRoutes: {
            auth: "auth/",
            supervisor: "supervisor/",
            member: "group/:groupId/member/:userId/",
            memberUrl: "group/default/member/{{userId}}/",
            payment: "payment/"
        },

        initialize: function (prefix, opt) {
            this.ctrl = {
                auth: new AuthenticationCtrl(this.url.auth, {role: null}),
                supervisor: new SupervisorCtrl(this.url.supervisor, {role: 'supervisor'}),
                member: new MemberCtrl(this.url.member, {
                    url: this.url.memberUrl,
                    role: 'client'
                }),
                payment: new PaymentCtrl(this.url.payment, {})
            };

        },

        // default ("otherwise") route
        index: function () {
            // I had to write the code here as a workaround because Zoom's callback is weird and I didn't find any solutions
            var queryString = location.search;
            var params = U.parseQueryString(queryString.substr(1, queryString.length));

            if (params.code) {
                var controller = new ZoomCtrl(params.code);
                controller.process();
            } else {
                this.redirect(this.url.member);
            }
        }

    });

    return AppRouter;

});

